<template>
    <div style="display: flex; flex-direction: column; font-weight: 500">
        <div style="background: linear-gradient(180deg, #ffdfca 0%, #ffffff 72.92%); position: relative">
            <div style="position: absolute; left: 50%; transform: translateX(-50%); z-index: 1">
                <img style="width: 168px" :src="require('@/assets/img/lite_back_img.png')" alt="" />
            </div>
            <div @click.stop="() => { $GlobalStore.closeLastModal() }" style="display: flex; align-items: center; gap: 4px; padding-left: 20px; padding-top: 26px; padding-bottom: 14px">
                <img style="width: 10px" :src="require('@/assets/img/gray_back_btn.png')" alt="" />
                <div style="font-size: 14px; font-weight: 500">뒤로가기</div>
            </div>
            <div style="font-weight: 700; font-size: 32px; line-height: 46px; text-align: center; margin-top: 20px">포지션 찾기 lite</div>
            <div style="font-weight: 500; line-height: 24px; text-align: center">쉽고 빠르게 찾는 나의 포지션</div>
            <div @click="startFindPosition" style="position: relative; z-index: 2; height: 40px; width: 198px; border-radius: 22.5px; background-color: var(--color-main); margin: 0 auto; line-height: 40px; text-align: center; font-size: 14px; font-weight: 500; margin-top: 14px; margin-bottom: 16px; color: #fff">시작하기</div>
        </div>

        <div style="flex: 1; overflow-y: scroll; padding-top: 10px">
            <div class="hide_scroll" style="display: flex; overflow-x: scroll; margin-top: 10px; border-top: 1px solid #ededed; border-bottom: 1px solid #ededed; padding: 12px 20px">
                <div class="cont_wrap_box">
                    <div class="title">포지션 찾기 수</div>
                    <div class="sub_title">누적</div>
                    <div class="sub_title2">{{ position_try_count | comma }}회</div>
                </div>
                <div style="padding-left: 16px" class="cont_wrap_box">
                    <div class="title">비용</div>
                    <div class="sub_title">₩</div>
                    <div class="sub_title2">무료</div>
                </div>
                <div style="padding-left: 16px" class="cont_wrap_box">
                    <div class="title">이용 횟수</div>
                    <div class="sub_title">최대</div>
                    <div class="sub_title2">하루에 한 번</div>
                </div>
                <div style="padding-left: 16px; border: none; padding-right: 0" class="cont_wrap_box">
                    <div class="title">리워드</div>
                    <div style="display: flex">
                        <div style="text-align: center; padding-right: 8px; position: relative">
                            <div style="margin-bottom: 8px" class="sub_title">포지션 뱃지</div>
                            <div style="display: flex; gap: 4px">
                                <img style="width: 20px" :src="require('@/assets/img/reward_3.png')" alt="" />
                                <img style="width: 20px" :src="require('@/assets/img/reward_4.png')" alt="" />
                            </div>
                            <div style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); width: 1px; height: 28px; background-color: #ededed"></div>
                        </div>
                        <div style="text-align: center; padding: 0 8px; padding-right: 0; position: relative">
                            <div style="margin-bottom: 8px" class="sub_title">프로필 이미지</div>
                            <img style="width: 54px" :src="require('@/assets/img/reward_5.png')" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div style="margin-top: 32px; padding: 0 20px">
                    <div style="font-size: 20px; font-weight: 500">포지션 찾기 lite</div>
                    <div style="margin-top: 10px; font-size: 14px; font-weight: 500; line-height: 24px">축구 포지션에 대한 정확도 높은 데이터를 바탕으로 제작된 사커하우만의 포지션 찾기입니다. 오직 사커하우에서만 할 수 있죠.</div>
                    <div style="margin-top: 26px; font-size: 14px; font-weight: 500; line-height: 24px">몇 분도 안 걸리는 시간을 내어 회원님의 축구 포지션을 찾아보세요. 버튼만 누르다보면 어느새 회원님에게 맞는 포지션 결과가 완성됩니다!</div>
                </div>
                <div style="height: 1px; width: calc(100% - 40px); background-color: #ededed; margin: 32px auto"></div>
                <div style="">
                    <div style="font-size: 20px; font-weight: 500; line-height: 24px; padding-left: 20px">결과의 정확도를 높이는<br />사커하우 포지션 찾기 가이드</div>
                    <swiper style="margin-top: 8px; height: 142px; padding: 0 20px" ref="filterSwiper" :options="swiperOption" role="tablist">
                        <swiper-slide v-for="(each, i) in guideList" :key="i" style="width: 100%; display: flex; justify-content: center; height: 116px">
                            <div style="padding: 8px 12px; background-color: #f5f5f5; border-radius: 12px">
                                <div style="display: flex; align-items: center; gap: 8px">
                                    <img style="width: 20px" :src="each.imgPath" alt="" />
                                    <div style="font-weight: 500; font-size: 14px; color: var(--color-main); line-height: 24px; margin-bottom: 4px">{{ each.title }}</div>
                                </div>
                                <div style="font-size: 14px; font-weight: 500; line-height: 24px">{{ each.contents }}</div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination paging_text" slot="pagination" style="width: 100%; font-size: 12px; display: inline-block"></div>
                    </swiper>
                    <div style="height: 1px; width: calc(100% - 40px); background-color: #ededed; margin: 32px auto; margin-top: 22px"></div>
                    <div style="padding-left: 20px; font-size: 20px; font-weight: 500; line-height: 24px; margin-bottom: 8px">다양한 질문들이 있어요</div>
                    <div class="hide_scroll" style="display: flex; overflow-x: scroll; padding: 0 20px; gap: 24px; margin-bottom: 12px">
                        <div v-for="index in 2" :key="index">
                            <img style="width: 200px" :src="require(`@/assets/img/position_lite_img${index}.png`)" alt="" />
                        </div>
                    </div>
                    <div style="padding: 0 28px">
                        <CircleText>
                            <div style="font-weight: 500; font-size: 12px; line-height: 20px">체력, 공 제어 감각, 모험심, 상황 파악 능력 등을 질문합니다.</div>
                        </CircleText>
                        <CircleText>
                            <div style="font-weight: 500; font-size: 12px; line-height: 20px">포지션 코멘트와 함께 어떠한 역할의 포지션인지 설명합니다.</div>
                        </CircleText>
                    </div>
                    <div style="height: 1px; width: calc(100% - 40px); background-color: #ededed; margin: 32px auto"></div>
                    <div style="padding: 0 20px; font-size: 20px; font-weight: 500; line-height: 24px">
                        <div>프로들의 추천</div>
                        <img style="width: 350px; margin-top: 8px; margin-bottom: 12px" :src="require('@/assets/img/position_pro.png')" alt="" />
                        <div style="display: flex; justify-content: space-between">
                            <div style="font-size: 12px; font-weight: 500; line-height: 20px">나의 축구 능력치를 분석하는 포지션 찾기!<br />훈련 방법과 전문적인 피드백을 제공합니다.</div>
                            <div @click="findPositionPro" style="width: 93px; height: 36px; line-height: 36px; border-radius: 22.5px; background-color: #f5f5f5; color: var(--color-main); text-align: center; font-size: 12px; font-weight: 500">바로 가기</div>
                        </div>
                    </div>
                    <div style="height: 1px; width: calc(100% - 40px); background-color: #ededed; margin: 32px auto"></div>
                    <div style="padding: 0 20px; padding-bottom: 60px">
                        <div style="font-size: 20px; font-weight: 500; line-height: 24px">포지션 정보</div>
                        <div style="font-size: 12px; font-weight: 500; line-height: 20px; margin-top: 4px; margin-bottom: 12px">포지션 정보는 4-4-2 포메이션을 기반으로 제공됩니다. 전술에 따라 유동성이 있는 포지션의 명칭은 제외하며, 가장 대표적인 포지션만 적용됩니다.</div>
                        <div style="padding: 8px 16px; background-color: #f5f5f5; border-radius: 12px">
                            <div style="margin-bottom: 8px">
                                <div class="pos_title">공격</div>
                                <div class="pos_wrap">
                                    <div class="pos_txt">중앙 공격수</div>
                                    <div class="pos_main">CF</div>
                                </div>
                                <div class="pos_wrap">
                                    <div class="pos_txt">세컨드 스트라이커</div>
                                    <div class="pos_main">SS</div>
                                </div>
                                <div style="border: none" class="pos_wrap">
                                    <div class="pos_txt">윙 포워드</div>
                                    <div class="pos_main">LWF / RWF</div>
                                </div>
                                <div style="height: 4px; background-color: #ededed; width: calc(100% + 32px); margin-left: -16px"></div>
                            </div>
                            <div style="margin-bottom: 8px">
                                <div class="pos_title">미드필더</div>
                                <div class="pos_wrap">
                                    <div class="pos_txt">공격형 미드필더</div>
                                    <div class="pos_main">AM</div>
                                </div>
                                <div class="pos_wrap">
                                    <div class="pos_txt">중앙 미드필더</div>
                                    <div class="pos_main">CM</div>
                                </div>
                                <div class="pos_wrap">
                                    <div class="pos_txt">수비형 미드필더</div>
                                    <div class="pos_main">DM</div>
                                </div>
                                <div style="border: none" class="pos_wrap">
                                    <div class="pos_txt">측면 미드필더</div>
                                    <div class="pos_main">LM / RM</div>
                                </div>
                                <div style="height: 4px; background-color: #ededed; width: calc(100% + 32px); margin-left: -16px"></div>
                            </div>
                            <div>
                                <div class="pos_title">수비</div>
                                <div class="pos_wrap">
                                    <div class="pos_txt">중앙 수비수</div>
                                    <div class="pos_main">CB</div>
                                </div>
                                <div class="pos_wrap">
                                    <div class="pos_txt">풀백</div>
                                    <div class="pos_main">LB / RB</div>
                                </div>
                                <div style="border: none; padding-bottom: 0;" class="pos_wrap">
                                    <div class="pos_txt">윙백</div>
                                    <div class="pos_main">LWB / RWB</div>
                                </div>
                            </div>
                        </div>
                        <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: #808080; margin-top: 12px;">골키퍼(GK)는 포지션 찾기 PRO를 통해서만 찾을 수 있습니다.</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div>
            <div style="text-align: center; font-weight: 500; font-size: 14px; color: #606060; margin-top: 10px;">오늘 진행한 포지션 찾기: 1회 진행/1회 남음</div>
            <div @click="next(start)" class="btn_style">{{ start ? "다음" : "포지션 찾기" }}</div>
        </div> -->
    </div>
</template>

<script>
import { CircleText } from "@/components/common";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
// import moment from 'moment'

export default {
    name: "FindPositionStart",
    components: { swiper, swiperSlide, CircleText },
    props: {
        completeAction: {
            type: Function,
            default: () => { },
        },
        position: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            rotate: false,
            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 20, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                },
                curIndex: 0,
            },
            guideList: [
                { title: '축구팀에서의 "나"를 기준', contents: "테스트 속 질문의 기준은 현재 혹은 과거 운동 경험에서 느낀 본인의 운동 능력치를 기준으로 평가해주세요. 축구팀이 있다면 팀에서의 운동 능력을 기준으로 해주세요.", imgPath: require("@/assets/img/pro_guide_1.png") },
                { title: "확실한 정도에 체크", contents: "보다 정확한 포지션 찾기 결과를 제공받기 위해서는 확실한 측정치에 체크해야 합니다.", imgPath: require("@/assets/img/pro_guide_2.png") },
                { title: "축구 MBTI", contents: "운동 능력과 포지션에 대한 다양한 데이터를 기반으로 제작된 축구 포지션 찾기입니다. 축구 MBTI처럼 진행하시면 됩니다.", imgPath: require("@/assets/img/pro_guide_3.png") },
            ],
            position_try_count: 0,
        };
    },
    methods: {
        // next(start) {
        //     if (start) {
        //         this.$GlobalStore.addModal("FindPositionStart", { completeAction: this.completeAction, position: this.position });
        //     } else {
        //         this.$GlobalStore.showProgress();

        //         setTimeout(() => {
        //             this.$GlobalStore.hideProgress();
        //             this.$GlobalStore.addModal("MyPosition", { completeAction: this.completeAction, position: this.position });
        //         }, 1200);
        //     }
        // },
        startFindPosition() {
            // const savePositionTime = localStorage.getItem('savePositionTime')

            // let isPassd24Hours;
            // if (savePositionTime) {
            //     const transTime = moment(savePositionTime, 'YYYY-MM-DD HH:mm:ss')
            //     const now = moment()
            //     isPassd24Hours = now.diff(transTime, 'hours') >= 24
            // }

            // if (isPassd24Hours || !savePositionTime) {
            //     if (savePositionTime) {
            //         localStorage.removeItem('savePositionTime')
            //     }
            //     this.$GlobalStore.addModal("MyPosition", { completeAction: this.completeAction, position: this.position });
            // } else {
            //     this.$GlobalStore.showAlert('포지션 찾기 lite는 24시간에 한 번만 할 수 있습니다.')
            // }

            this.$GlobalStore.addModal("MyPosition", { completeAction: this.completeAction, position: this.position });


        },
        findPositionPro() {
            this.$GlobalStore.addModal('FindPositionProStart', { originallyPosition: this.$GlobalStore.loginInfo().position });
        },
        async getPositionTryCount() {
            const res = await this.$Axios.get('/api/position/try/count');
            this.position_try_count = res.data.position_try_count;
        }
    },
    created() {
        this.getPositionTryCount();
    }
};
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.btn_style {
    width: calc(100% - 40px);
    margin: 0 auto;
    height: 47px;
    border-radius: 40px;
    color: #fff;
    background-color: var(--color-main);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 70px;
    margin-top: 20px;
}

.mini_circle {
    display: inline-block;
    width: 4px;
    height: 4px;
    background-color: #808080;
    border-radius: 50%;
    margin-right: 4px;
}

.rotate {
    transform: rotate(180deg);
    transition: all 1s;
}

.question_mark {
    display: inline-block;
    color: #606060;
    font-weight: 900;
    font-size: 13px;
    width: 16px;
    height: 13px;
    border-radius: 3px;
    background-color: #d9d9d9;
    text-align: center;
}

.cont_wrap_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #ededed;
    padding-right: 16px;
    white-space: nowrap;
}

.title {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: #606060;
}

.sub_title {
    font-size: 10px;
    font-weight: 500;
    line-height: 20px;
    color: #808080;
}

.sub_title2 {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
}

.swiper .swiper-pagination {
    position: absolute;
    bottom: 65px !important;
}

.swiper-pagination>>>.swiper-pagination-bullet {
    background: #d9d9d9;
    width: 6px;
    height: 6px;
    opacity: 1;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: var(--color-main);
}

.pos_title {
    font-size: 12px;
    font-weight: 700;
    line-height: 24px;
    border-bottom: 1px solid #ededed;
    padding-bottom: 8px;
}

.pos_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #ededed;
}

.pos_txt {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: #808080;
}

.pos_main {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
}
</style>
